export default __webpack_public_path__ + "assets/images/e9453f12ac86898eaeba7536ac6af83c.png";